import React, {FC} from 'react';

import {TeammateModel} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {TeammateAvatar} from '../../../../libs/shared/ui/src/components/avatar/teammateAvatar';
import {DropdownItemAvatar} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemAvatar';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

export interface DropdownItemTeammateAvatarProps {
  /** The teammate to display. */
  teammate: TeammateModel;
}

/*
 * Component.
 */

export const DropdownItemTeammateAvatar: FC<DropdownItemTeammateAvatarProps> = ({teammate}) => (
  <DropdownItemAvatar>
    <TeammateAvatar teammate={teammate} size={VisualSizesEnum.MEDIUM} />
  </DropdownItemAvatar>
);
